import React, {useEffect} from 'react';
import config from "../../../../../../../../config";


const WebChatTest = (props) => {
    const scriptId = "TSChatSDK";
    const companyId = props.companyId;

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `${config.WEBCHAT_HOST}/sdk.bundle.js?version=1.7.4&companyId=` + companyId + "";
        script.id = scriptId;
        script.type = "text/javascript"
        document.querySelector("body").appendChild(script)

        return () => {
            document.querySelector("body").removeChild(document.querySelector(`#${scriptId}`));
            document.querySelector("body").removeChild(document.querySelector(".ts-chatbot-wrapper"))
        }
    }, [])

    return (
        <div>
        </div>
    );
};

export default WebChatTest;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/WebChatTest.jsx